import { TimelineMax } from "gsap/TweenMax";
import $ from "jquery";

const autoScroll = (el) => {
    const $el = $(el);

    const direction = $el.data("direction");
    const $list = $el.find("ul");

    const $clone = $el.clone();
    const $wrapper = $el.parent();

    const infinite = new TimelineMax({ repeat: -1, paused: false });

    const $heightDiff = 24; //24px space between column lists
    const listHeight = $list.innerHeight() + $heightDiff; //doesn't update between page loads

    $el.add($clone).css({
        height: listHeight + "px",
    });

    $clone.addClass("state--clone").appendTo($wrapper);

    const quickItemSpeed = 3.8; // Approx. per 100px width, lower = faster
    const slowItemSpeed = 4.8; // Approx. per 100px width, lower = faster

    const quickColumnSpeed = (listHeight / 100) * quickItemSpeed;
    const slowColumnSpeed = (listHeight / 100) * slowItemSpeed;

    const ease = Linear.easeNone;

    if (direction === "down") {

        infinite.fromTo(
            $el,
            quickColumnSpeed,
            { top: 0 },
            { top: listHeight, ease: ease },
          {  immediateRender: false},
            0
        );

        infinite.fromTo(
            $clone,
            quickColumnSpeed,
            { top: -listHeight },
            { top: 0, ease: ease },
            0
        );

        infinite.set($el, { top: -listHeight });

        infinite.to(
            $clone,
            quickColumnSpeed,
            { top: listHeight, ease: ease },
            quickColumnSpeed
        );

        infinite.to(
            $el,
            quickColumnSpeed,
            { top: 0, ease: ease },
            quickColumnSpeed
        );

        infinite.progress(0.15);
        infinite.play();
    }

    if (direction === "up") {

        infinite.fromTo(
            $el,
            slowColumnSpeed,
            { bottom: 0 },
            { bottom: listHeight, ease: ease },
          {  immediateRender: false},
            0
        );

        infinite.fromTo(
            $clone,
            slowColumnSpeed,
            { bottom: -listHeight },
            { bottom: 0, ease: ease },
            0
        );

        infinite.set($el, { bottom: -listHeight });

        infinite.to(
            $clone,
            slowColumnSpeed,
            { bottom: listHeight, ease: ease },
            slowColumnSpeed
        );

        infinite.to(
            $el,
            slowColumnSpeed,
            { bottom: 0, ease: ease },
            slowColumnSpeed
        );

        infinite.progress(0.1);
        infinite.play();
    }



    const handlePlay = () => {
        $(".button").attr("aria-pressed", false);
        document.querySelector(".play-icon").style.display = "none";
        document.querySelector(".pause-icon").style.display = "block";
        infinite.play();
    };

    const handlePause = () => {
        $(".button").attr("aria-pressed", true);
        document.querySelector(".pause-icon").style.display = "none";
        document.querySelector(".play-icon").style.display = "block";
        infinite.pause();
    };

    $(".button").on("click", () => {
        infinite._paused ? handlePlay() : handlePause();
    });

};

export default autoScroll;
